module.exports = __webpack_public_path__ + "img/advantage6Blue.db368668.png";